import request from "@api/request";
import { endpoints } from "@constants/endpoints";

import type { AxiosResponse } from "axios";
import type { OrderDto } from "@interfaces/stats";

export const getOrdersStatistic = async (): Promise<
  AxiosResponse<OrderDto[]>
> =>
  await request({
    url: endpoints.ORDERS_STAT,
    method: "GET",
  });
